export enum BusinessType {
    utility_bill = 'utility_bill',
    telephone_bill = 'telephone_bill',
    bank_statement = 'bank_statement',
    lease_agreement = 'lease_agreement',
    trading_permit = 'trading_permit',
    sars_tax = 'sars_tax',
    business_logo = 'business_logo',
}
